import { AddItemButton } from '@core/components/Buttons';
import FormTitle from '@core/components/FormTitle';
import { DateInput } from '@core/components/Inputs';
import CodigoBarrasInput from '@core/components/Inputs/CodigoBarrasInput';
import {
  Box,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputBase,
  makeStyles,
  Switch,
  Tooltip,
  Typography,
} from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectConta from 'app/components/Select/SelectConta';
import { FieldArray } from 'formik';
import React, { Fragment, useState } from 'react';
import { MdHighlightOff } from 'react-icons/md';
import { ContasPagarUtil } from '../store/contasPagarAction';
import FormaDePagamento from './FormaDePagamento';

const exibirDiferenca = (values) => {
  const valorDiferenca = ContasPagarUtil.calcularDiferencaParcelas(values);
  return (
    valorDiferenca !== 0 && (
      <Grid item xs={12} sm={12}>
        <InputBase
          inputProps={{ 'aria-label': 'naked' }}
          style={{ color: 'red' }}
          value={`Diferença ${new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
          }).format(valorDiferenca)}`}
        />
      </Grid>
    )
  );
};

const useStyles = makeStyles({
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: 16,
  },
  dividerTitle: {
    backgroundColor: '#707070',
    marginBottom: 8,
    opacity: '0.5',
  },
  title: {
    fontSize: 15,
    fontWeight: 500,
  },
  viewMore: {
    color: '#53c4e6',
    textTransform: 'capitalize',
    '&:hover, &:focus': {
      cursor: 'pointer',
    },
  },
});
const ContasPagarParcelas = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  showMoreTitle = 'Ver mais',
  origemCompra,
}) => {
  const parcelas = values?.parcelamento?.parcelas;
  const parcelasTouched = touched?.parcelamento?.parcelas || [];
  const parcelasErrors = errors?.parcelamento?.parcelas || [];

  /*
  RNE-478 - Edição de conta a pagar
  Para as contas a pagar que estiverem com situação "Baixada", somente a aba “Anexar documento” deve ser exibida com possibilidade de edição. Todos os outros campos das outras abas devem ser exibidos desabilitados para edição.
  */
  const contaBaixada = values?.situacao === 'BAIXADA';

  const temParcelaBaixada = values?.parcelamento?.parcelas?.some(
    (parcela) => parcela?.situacao === 'BAIXADA' || parcela?.situacao === 'PARCIAL'
  );

  const [tamanho, setTamanho] = useState(5);
  const styles = useStyles();
  const existeMais = parcelas.length - tamanho > 0;

  return (
    <>
      <Grid container item spacing={3}>
        <Grid item xs={12}>
          <FormTitle title="Parcelas" />
        </Grid>
      </Grid>

      <FieldArray name="parcelamento.parcelas">
        {(arrayHelpers) => {
          const parcelasAdicionadas =
            parcelas &&
            parcelas.slice(0, tamanho).map((parcela, index) => {
              const readOnly = temParcelaBaixada || contaBaixada;
              return (
                <Fragment key={index}>
                  <Grid container item spacing={3} alignItems="center">
                    <Grid item xs={6}>
                      <p className={styles.title}>{`Parcela ${index + 1}`}</p>
                    </Grid>
                    <Grid xs={6}>
                      <Box display="flex" justifyContent="flex-end">
                        {index !== 0 && !readOnly && !temParcelaBaixada && (
                          <Tooltip title="Excluir parcela" placement="bottom">
                            <IconButton onClick={() => arrayHelpers.remove(index)}>
                              <MdHighlightOff size={18} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid xs={12}>
                    <Divider variant="middle" className={styles.dividerTitle} />
                  </Grid>
                  <Grid container style={{ marginLeft: 2, marginTop: 4 }} spacing={3} className="mb-8">
                    <Grid item xs={12} sm={4}>
                      <DateInput
                        disabled={readOnly || contaBaixada}
                        fullWidth
                        required
                        id={`parcelamento.parcelas[${index}].dataVencimento`}
                        label="Data do vencimento"
                        value={parcela?.dataVencimento}
                        touched={parcelasTouched[index]?.dataVencimento}
                        error={parcelasErrors[index]?.dataVencimento}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <InputMonetario
                        fullWidth
                        required
                        disabled={readOnly || contaBaixada || origemCompra}
                        id={`parcelamento.parcelas[${index}].valorLiquido`}
                        label="Valor parcelado líquido (R$)"
                        onBlur={handleBlur}
                        value={parcela?.valorLiquido}
                        touched={parcelasTouched[index]?.valorLiquido}
                        error={parcelasErrors[index]?.valorLiquido}
                        handleChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                  <Grid container style={{ marginLeft: 2 }} spacing={3} className="mb-8">
                    <Grid item xs={12} sm={4}>
                      <SelectConta
                        required={parcela?.contemBaixa}
                        id={`parcelamento.parcelas[${index}].conta`}
                        fullWidth
                        disabled={readOnly || contaBaixada}
                        label="Conta"
                        value={parcela?.conta}
                        onChange={(event) => {
                          handleChange(event);
                          handleChange({
                            target: { id: `parcelamento.parcelas[${index}].formaPagamento`, value: undefined },
                          });
                        }}
                        touched={parcelasErrors[index]?.conta}
                        error={parcelasErrors[index]?.conta}
                        onBlur={handleBlur}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormaDePagamento
                        required={parcela?.contemBaixa}
                        id={`parcelamento.parcelas[${index}].formaPagamento`}
                        disabled={readOnly || contaBaixada}
                        value={parcela?.formaPagamento}
                        handleChange={handleChange}
                        onBlur={handleBlur}
                        maxLength={20}
                        tipoConta={parcela?.conta?.tipo}
                        touched={parcelasErrors[index]?.formaPagamento}
                        error={parcelasErrors[index]?.formaPagamento}
                      />
                    </Grid>
                    <FormControlLabel
                      label="Informar código de barras"
                      disabled={readOnly || contaBaixada}
                      control={
                        <Switch
                          id={`parcelamento.parcelas[${index}].informarCodigoBarras`}
                          name={`parcelamento.parcelas[${index}].informarCodigoBarras`}
                          value={parcela?.informarCodigoBarras}
                          checked={parcela?.informarCodigoBarras}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          size="small"
                          color="primary"
                        />
                      }
                    />
                  </Grid>
                  {parcela?.informarCodigoBarras && (
                    <Grid item xs={12}>
                      <CodigoBarrasInput
                        required
                        id={`parcelamento.parcelas[${index}].linhaDigitavel`}
                        name={`parcelamento.parcelas[${index}].linhaDigitavel`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={parcela?.linhaDigitavel}
                        disabled={readOnly || contaBaixada}
                        touched={parcelasTouched[index]?.linhaDigitavel}
                        error={parcelasErrors[index]?.linhaDigitavel}
                        fullWidth
                        variant="outlined"
                        label="Código de barras"
                        borderRed
                      />
                    </Grid>
                  )}
                </Fragment>
              );
            });
          return (
            <>
              {parcelasAdicionadas}
              {existeMais ? (
                <Grid xs={12} item spacing={3} style={{ paddingTop: 0 }}>
                  <Typography className={styles.viewMore}>
                    <b className={styles.viewMore} onClick={() => setTamanho(tamanho + 5)}>
                      {showMoreTitle}
                    </b>
                  </Typography>
                </Grid>
              ) : (
                !contaBaixada &&
                !temParcelaBaixada && (
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <AddItemButton onClick={() => arrayHelpers.push({})}>Adicionar parcela</AddItemButton>
                  </Grid>
                )
              )}
            </>
          );
        }}
      </FieldArray>
      {exibirDiferenca(values)}
      <Grid xs={12} item spacing={3}>
        <Divider style={{ background: 'rgba(0,0,0,0.5)' }} />
      </Grid>
    </>
  );
};

export default ContasPagarParcelas;
